<template>
  <div class="icon icon--times">
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Kopieren in Zwischenablage"
        role="img"
        viewBox="0 0 352 502"
        style="overflow: visible"
      >
        <g>
          <g>
            <g>
              <path
                d="M467.628,190.176l-70.469-70.468c-1.876-1.875-4.419-2.929-7.071-2.929h-76.473V80.468c0-2.652-1.054-5.196-2.929-7.071
L240.219,2.929C238.342,1.054,235.8,0,233.146,0H41.443c-5.522,0-10,4.477-10,10v365.221c0,5.523,4.478,10,10,10h146.941V492
c0,5.523,4.478,10,10,10h262.172c5.522,0,10-4.477,10-10V197.247C470.557,194.595,469.503,192.051,467.628,190.176z
M400.089,150.921l18.163,18.163l18.163,18.163h-36.326V150.921z M243.147,34.142l18.163,18.163l18.163,18.163h-36.326V34.142z
M87.287,116.779c-5.522,0-10,4.477-10,10s4.478,10,10,10h101.099v29.919H87.287c-5.522,0-10,4.477-10,10s4.478,10,10,10h101.099
v30.01H87.287c-5.522,0-10,4.477-10,10c0,5.523,4.478,10,10,10h101.099v30.009H87.287c-5.522,0-10,4.477-10,10s4.478,10,10,10
h101.099v78.504H51.443V20h171.703v60.468c0,5.523,4.478,10,10,10h60.469v26.311H87.287z M450.557,482H208.386V136.779h171.703
v60.468c0,5.523,4.478,10,10,10h60.469V482z"
              />
              <path
                d="M244.229,253.468H369.63c5.522,0,10-4.477,10-10c0-5.523-4.478-10-10-10H244.229c-5.522,0-10,4.477-10,10
C234.229,248.991,238.706,253.468,244.229,253.468z"
              />
              <path
                d="M414.714,283.478H244.229c-5.522,0-10,4.477-10,10s4.478,10,10,10h170.486c5.522,0,10-4.477,10-10
S420.237,283.478,414.714,283.478z"
              />
              <path
                d="M414.714,333.487H244.229c-5.522,0-10,4.477-10,10s4.478,10,10,10h170.486c5.522,0,10-4.477,10-10
S420.237,333.487,414.714,333.487z"
              />
              <path
                d="M414.714,383.497H244.229c-5.522,0-10,4.477-10,10s4.478,10,10,10h170.486c5.522,0,10-4.477,10-10
S420.237,383.497,414.714,383.497z"
              />
              <path
                d="M398.044,253.468h16.67c5.522,0,10-4.477,10-10c0-5.523-4.478-10-10-10h-16.67c-5.522,0-10,4.477-10,10
C388.044,248.991,392.522,253.468,398.044,253.468z"
              />
            </g>
          </g>
        </g>
    </svg>
  </div>
</template>